var map = {
	"./background-.png": 563,
	"./background-About.png": 935,
	"./background-Contact.png": 316,
	"./background-Portfolio.png": 15,
	"./background-Services.png": 542,
	"./background-Skills.png": 353,
	"./background-education.png": 382,
	"./background-menu.png": 141,
	"./background-portfolio-console.png": 431,
	"./background-portfolio-desktop.png": 157,
	"./background-portfolio-mobile.png": 212,
	"./background-portfolio-web.png": 638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;